import React from 'react';
import { useDispatch } from 'react-redux';

import { Payable } from 'services/action';
import { Page } from 'ui/components';
import {
  Action,
  DetailPayable,
  DetailDescription,
  PaymentList
} from './component/detail';

const initialState = {
  data: null,
};

const DetailScreen = ({ match }) => {
  const Dispatch = useDispatch();

  const [{ data }, setState] = React.useState(initialState);

  const $onLoad = async (e) => {
    const req = await Dispatch(Payable.$show(e));

    if (req?.message === 'success') {
      setState((prevState) => ({ ...prevState, data: req?.data }));
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  return (
    <Page className="col-lg-11 col-md-11 bordered">
      <Page.Header
        pretitle="Payable"
        title={data?.code}
        status={data?.document_status}
        backTo="/payable"
      >
        <Action data={data} onSubmit={() => $onLoad(match?.params?.id)} />
      </Page.Header>

      <Page.Body className="bg-white border-top padding mt-3 mt-md-0">
        <div className="row">
          <div className="col-md-9">
            <DetailPayable
              data={data}
            />

            <DetailDescription
              data={data}
            />
          </div>
          <div className="border-start border-sm-none col-md-3 mt-3 mt-md-0">
            <PaymentList
              data={data}
              onSubmit={() => $onLoad(match?.params?.id)}
            />
          </div>
        </div>
      </Page.Body>
    </Page>
  );
};

export default DetailScreen;
